<template>
  <div class="home">
    <!-- 在public/index.html 中设置user-scalable=no 
    <meta name="viewport" content="width=device-width,initial-scale=1.0,user-scalable=no"> 
    不然用户双击可以缩放
    之前遇到的flex宽度留白问题就是因为没注意这个,事实上是自己双击缩放了
    -->
    <div class="input">
      <input type="text" class="text" v-model="value" placeholder="请输入快递单号" @focus="isShowHistory=true" @blur="cancelFocus" value="">
      <div class="close-icon" @click="value=''"></div>
      <div class="search-icon" @click="search"></div>
      <div class="history" v-if="isShowHistory&&expressCode.length>=0">
        <div class="historyItem" v-for="code,i in expressCode" :key="i" @click="chooseExpressCode(code)">{{code}}</div>
      </div>
    </div>
    
    <div class="searchResult">
      <div class="content" v-if="data.length>0">
        <div class="header">
          <div class="time">
            <div class="text">时间</div>
            <div class="icon" @click="sort=!sort">
              <span class="topT" :class="{active:sort}"></span>
              <span class="botT" :class="{active:!sort}"></span>
            </div>
          </div>
          <div class="addr">地点和跟踪进度</div>
        </div>

        <div class="list">
          <div class="listItem" v-for="item,index in showList" :key="index" :class="{active:(sort&&index==0)||(((!sort)&&index==(showList.length-1)))}">
            <div class="liTime">
              <!-- 第一种分割方法，比较麻烦，slice -->
              <!-- <div class="data">{{item.time.slice(0,11)}}</div>
              <div class="hour">{{item.time.slice(11,16)}}</div> -->
              <!-- 第二种分割方法，常用，split -->
              <div class="data">{{item.time.split(" ")[0]}}</div>
              <div class="hour">{{item.time.split(" ")[1]}}</div>
            </div>
            <div class="liMid">
              <div class="circle" :class="{active:(sort&&index==0)||(((!sort)&&index==(showList.length-1)))}"></div>
              <div class="line"></div>
            </div>
            <div class="addrTxt">{{item.status}}</div>
          </div>
        </div>
      </div>
      <div v-else>
        <h3 style="color: #ccc;text-align: center">尚无搜索结果</h3>
      </div>
    </div>

  </div>
</template>

<script>
// @ is an alias to /src
import axios from 'axios'

export default {
  name: 'Home',
  data:function(){
    return{
      value:"SF1980994583037:6029",
      data:[],
      sort: true,
      isShowHistory:false,
      expressCode:[]
    }
  },
  created(){
    this.value = ""
  },
  mounted(){
    this.expressCode =localStorage.expressCode?JSON.parse(localStorage.expressCode):[]
  },
  computed:{
    showList(){
      if(this.sort){
        // console.log(this.sort)
        return [...this.data]
      }else{
        // console.log(this.sort)
        return [...this.data].reverse()
      }
    }
  },
  methods:{
    async search(){
      // 手机号后四位
      // let phoneNum = '6029'
      let httpUrl = `https://wuliu.market.alicloudapi.com/kdi?no=${this.value}`
      let config = {
        headers:{
          "Authorization":"APPCODE 1153fde779fa4eb69a59c0301d961062"
        }
      }
      let res = await axios.get(httpUrl,config)
      if(res.data.status == "0"){
        let data = res.data.result.list
        this.data = data;
        this.saveExpressHistory();
      }else{
        alert("请输入正确的快递单号！")
      }
      console.log(this.data)
      console.log(res)
    },
    // 封装成一个方法
    // 将搜索记录保存本地 
    saveExpressHistory(){
      // 首先从本地存储里查看是否有存放的历史快递单号，如果有就用Json解析出来，没有就创建一个新的数组
      this.expressCode = localStorage.expressCode?JSON.parse(localStorage.expressCode):[]
      // 判断数组是否已存在这个单号,indexOf返回寻找内容的下标，=-1说明没有找到
      if(this.expressCode.indexOf(this.value) == -1){
          this.expressCode.push(this.value)
          localStorage.expressCode = JSON.stringify(this.expressCode)
      }
    },
    chooseExpressCode(code){
      this.value = code;
      this.search();

      //  @blur="isShowHistory=false"使这个内容消失的太快，点不到 
      this.isShowHistory = false
    },
    cancelFocus(){
      setTimeout(()=>this.isShowHistory=false,50)
    }
  }
}
</script>

<style lang="scss">
$font-color:#317ee7;
.history{
  position: absolute;
  left: 0;
  top: 0.5rem;
  width: 3.55rem;
  display: flex;
  flex-direction: column;
  box-shadow: 0px 2px 6px #ccc;
  background-color: #fff;
  z-index: 10;
  .historyItem{
    width: 3.55rem;
    height: 0.44rem;
    line-height: 0.44rem;
    padding: 0 0.2rem;
    color: $font-color;  
  }
}
html{
  font-size: calc(100vw/3.75);
}
body{
  font-size: 0.16rem;
  margin: 0;
  padding: 0;
  // box-sizing: border-box;
  font-family: "Microsoft YaHei", Verdana, arial, sans-serif;
}
@mixin background-image($url){
  background-image: url($url);
  background-size: 100% auto;
  background-repeat: no-repeat;
}
.home{
  @include background-image("../assets/topbanner.png");
  width: 100%;
  // 去掉，弹性布局，最后内容高过长，使得上面的内容压缩，input-div 变窄
  // height: 100vh;
  position: absolute;
  display: flex;
  flex-direction: column;
  align-items: center;
  .input{
    width: 3.55rem;
    height: 0.48rem;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #fff;
    border-radius: 0.05rem;
    box-shadow: 0 1px 10px #ccc;
    margin-top: 0.92rem;
    position: relative;
    .text{
      flex: 1;
      // height: 100%;
      border: none;
      outline: none;
      font-size: 0.16rem;
      padding: 0 0.2rem;
    }
    .close-icon{
      width: 0.20rem;
      height: 0.20rem;
      padding: 0 0.03rem;
      @include background-image('../assets/cancel.png');
      background-size: 80% auto;
      border-right: 1px solid #ccc;
    }
    .search-icon{
      width: 0.26rem;
      height: 0.26rem;
      margin: 0 0.08rem;
      @include background-image('../assets/search.png')
    }
  }
  $triColor : #ddd;
  // 向下的三角形
  @mixin triangleB($color:$triColor,$borderWidth:0.05rem){
    width: 0;
    height: 0;
    border-top: $borderWidth solid $color;
    border-bottom: $borderWidth solid transparent;
    border-left: $borderWidth solid transparent;
    border-right: $borderWidth solid transparent;
  }
  // 向上的三角形
  @mixin triangleT($color:$triColor,$borderWidth:0.05rem){
    width: 0;
    height: 0;
    border-top: $borderWidth solid transparent;
    border-bottom: $borderWidth solid $color;
    border-left: $borderWidth solid transparent;
    border-right: $borderWidth solid transparent;
  }
  // 最好控制在3-4层
  .searchResult{
    width: 100%;
    font-size: 0.14rem;
    .content{
      width: 100%;
      margin-top: 0.1rem;
      .header{
        width: 100vw;
        display: flex;
        justify-content: center;
        .time{
          width: 0.96rem;
          height: 0.2rem;
          display: flex;
          justify-content: center;
          .icon{
            width: 0.2rem;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            .topT{
              @include triangleT;
              margin-bottom: 0.02rem;
              &.active{
                @include triangleT($font-color);
              }
            }
            .botT{
              @include triangleB;
              &.active{
                @include triangleB($font-color);
              }
            }
          }
        }
        .addr{
          flex: 1;
          padding-left: 0.3rem;
        }
      }
    }
  }
}

.list{
  width: 100%;
  height: auto;
  display: flex;
  flex-direction: column;
  margin-top: 0.1rem;
  .listItem{
    width: 100vw;
    min-height: 0.56rem;
    display: flex;
    &.active{
      color: $font-color;
    }
    .liTime{
      width: 0.92rem;
      font-size: 0.12rem;
      text-align: center;
    }
    .liMid{
      width: 0.14rem;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      transform: translateY(0.03rem);
      .circle{
        width: 0.08rem;
        height: 0.08rem;
        border: 0.02rem solid #efefef;
        background-color: #888;
        border-radius: 50%;
        &.active{
          width: 0.12rem;
          height: 0.12rem;
          background-color: $font-color;
        }
      }
      .line{
        width: 1px;
        flex: 1;
        background-color: #eeeeee;
      }
    }
    .addrTxt{
      padding-left: 0.2rem;
      padding-bottom: 0.4rem;
      padding-right: 0.2rem;
      line-height: 0.2rem;
      flex: 1;
      height: auto;
    } 
  }
}

</style>